import { ColumnDef } from '@tanstack/react-table';
import { TruncatedCell } from '@/components';
import { formatPhoneNumber } from '@/utils/phoneUtils';
import { PatientDocumentViewButton } from '../../components';
import { DASH } from '../../utils/displayValues';
import { DocumentSource, DocumentType } from '../../viewer';
import { PatientProviderSummary } from '../types';

const NO_DATA = 'No data available';

const formatLocation = (city?: string, state?: string) => {
  if (city && state) return `${city}, ${state}`;
  if (city) return city;
  if (state) return state;
  return NO_DATA;
};

export const createProvidersColumns =
  (): ColumnDef<PatientProviderSummary>[] => [
    {
      accessorKey: 'name',
      header: 'Provider',
      cell: ({ row }) =>
        row.original.name === null ? (
          DASH
        ) : row.original.name ? (
          <TruncatedCell text={row.original.name} />
        ) : (
          NO_DATA
        ),
    },
    {
      accessorKey: 'specialty',
      header: 'Specialty',
      cell: ({ row }) =>
        row.original.specialty ? (
          <TruncatedCell text={row.original.specialty} />
        ) : (
          NO_DATA
        ),
    },
    {
      id: 'telephone',
      header: 'Telephone',
      cell: ({ row }) => {
        const { phoneNumber } = row.original;
        if (!phoneNumber) return NO_DATA;
        const formatted = formatPhoneNumber(phoneNumber);
        return formatted || phoneNumber;
      },
    },
    {
      id: 'location',
      header: 'City, State',
      cell: ({ row }) => formatLocation(row.original.city, row.original.state),
    },
    {
      id: 'sources',
      enableSorting: false,
      header: 'Sources',
      cell: ({ row }) => (
        <div className="flex items-center justify-start gap-1">
          <PatientDocumentViewButton
            disabled={!row.original.sourceType}
            documentKey={{
              source: DocumentSource.PROVIDERS,
              type: DocumentType.PATIENT_PROVIDERS,
              providerId: row.original.id,
              sourceType: row.original.sourceType,
              name: row.original.name === null ? DASH : row.original.name,
            }}
          />
        </div>
      ),
    },
  ];
